__turbopack_context__.v({
  "modal": "Vq1b0a_modal",
  "modalBody": "Vq1b0a_modalBody",
  "modalFooter": "Vq1b0a_modalFooter",
});
